import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  message,
  Row,
  Col,
  Checkbox,
  DatePicker,
  Upload,
  Modal,
} from "antd";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { postRequest } from "../utils/apicalls";
import { useNavigate } from "react-router-dom";
import "../styles/createintern.css";

const { Option } = Select;

const CreateInterns = () => {
  const [loading, setLoading] = useState(false);
  const [isStaffHouse, setIsStaffHouse] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      let response;

      if (!values.is_staffhouse) {
        // Walay Staff House
        const payload = {
          first_name: values.firstName,
          middle_name: values.middleName || null,
          last_name: values.lastName,
          suffix: values.suffix || null,
          school: values.school,
          type: values.type,
          course_program: values.courseProgram,
          personal_email: values.personal_email,
          company_email: values.company_email,
          contact_number: values.contactNumber,
          name_of_coordinator: values.nameofCoordinator,
          number_of_coordinator: values.numberofCoordinator,
          email_of_coordinator: values.emailofCoordinator,
          batch_number: values.batchNumber,
          hours_required: values.hours_required,
          is_staffhouse: 0,
          move_in_date: null,
          move_out_date: null,
          move_out_form: null,
        };

        response = await postRequest("interns/create", payload);
      } else {
        // Naay Staff House
        const formData = new FormData();

        formData.append("first_name", values.firstName);
        formData.append("middle_name", values.middleName || "");
        formData.append("last_name", values.lastName);
        formData.append("suffix", values.suffix || "");
        formData.append("school", values.school);
        formData.append("type", values.type);
        formData.append("course_program", values.courseProgram);

        formData.append("personal_email", values.personal_email);
        formData.append("company_email", values.company_email);

        formData.append("contact_number", values.contactNumber);

        formData.append("name_of_coordinator", values.nameofCoordinator);
        formData.append("number_of_coordinator", values.numberofCoordinator);
        formData.append("email_of_coordinator", values.emailofCoordinator);

        formData.append("batch_number", values.batchNumber);
        formData.append("hours_required", values.hours_required);

        formData.append("is_staffhouse", 1);

        formData.append(
          "move_in_date",
          values.move_in_date ? values.move_in_date.format("YYYY-MM-DD") : ""
        );

        formData.append(
          "move_out_date",
          values.move_out_date ? values.move_out_date.format("YYYY-MM-DD") : ""
        );

        if (fileList.length > 0) {
          formData.append("move_out_form", fileList[0].originFileObj);
        }

        response = await postRequest("interns/create", formData, true);
      }

      if (response?.intern_id) {
        message.success(response.message);

        form.resetFields();
        setFileList([]);
        setPreviewUrl("");

        navigate("/interns");
      } else {
        message.error(response?.message || "Failed to add intern");
      }
    } catch (err) {
      console.error(err);
      message.error("An error occurred while adding the intern.");
    }

    setLoading(false);
  };

  return (
    <div className="add-intern-form-container relative">
      <button className="close-button" onClick={() => navigate("/interns")}>
        <CloseOutlined />
      </button>

      <h2 className="create-form-title">Add New Intern</h2>

      <Form form={form} onFinish={handleSubmit} layout="vertical">
        {/* NAME INFORMATION */}
        <Row gutter={12}>
          <Col xs={24} md={6}>
            <Form.Item
              name="firstName"
              label="First Name"
              rules={[
                { required: true, message: "First Name is required" },
                { whitespace: true, message: "First Name cannot be empty" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={6}>
            <Form.Item name="middleName" label="Middle Name">
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={6}>
            <Form.Item
              name="lastName"
              label="Last Name"
              rules={[
                { required: true, message: "Last Name is required" },
                { whitespace: true, message: "Last Name cannot be empty" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={6}>
            <Form.Item name="suffix" label="Suffix">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        {/* SCHOOL INFO */}
        <Row gutter={12}>
          <Col xs={24} md={8}>
            <Form.Item name="type" label="Type" rules={[{ required: true }]}>
              <Select>
                <Option value="College">College</Option>
                <Option value="HS">HS</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              name="school"
              label="School"
              rules={[
                { required: true, message: "School is required" },
                { whitespace: true, message: "School cannot be empty" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              name="courseProgram"
              label="Course / Program"
              rules={[
                { required: true, message: "Course / Program is required" },
                {
                  whitespace: true,
                  message: "Course / Program cannot be empty",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        {/* CONTACT INFO*/}
        <Row gutter={12}>
          <Col xs={24} md={8}>
            <Form.Item
              name="personal_email"
              label="Personal Email"
              rules={[
                { required: true },
                { type: "email", mesage: "Invalid email address" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              name="company_email"
              label="Company Email"
              rules={[
                { required: true },
                { type: "email", mesage: "Invalid email address" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              name="contactNumber"
              label="Contact Number"
              rules={[
                { required: true, message: "Contact Number is required" },
                { pattern: /^\d{11}$/, message: "Must be exactly 11 digits" },
              ]}
            >
              <Input
                maxLength={11}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  form.setFieldsValue({ contactNumber: value });
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* COORDINATOR INFO*/}
        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item
              name="nameofCoordinator"
              label="Coordinator's Name"
              rules={[
                { required: true, message: "Coordinator Name is required" },
                {
                  whitespace: true,
                  message: "Coordinator Name cannot be empty",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="numberofCoordinator"
              label="Coordinator's Contact"
              rules={[
                { required: true, message: "Coordinator Contact is required" },
                { pattern: /^\d{11}$/, message: "Must be exactly 11 digits" },
              ]}
            >
              <Input
                maxLength={11}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  form.setFieldsValue({ numberofCoordinator: value });
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={12}>
          <Col xs={24} md={8}>
            <Form.Item
              name="emailofCoordinator"
              label="Coordinator's Email"
              rules={[{ required: true }, { type: "email" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              name="batchNumber"
              label="Batch Number"
              rules={[
                { required: true, message: "Batch Number is required" },
                {
                  pattern: /^[0-9]+$/,
                  message: "Batch Number must be numbers only",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              name="hours_required"
              label="Hours Required"
              rules={[
                {
                  required: true,
                  message: "Hours Required is required",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // ang required rule na ang mo-handle
                    }

                    if (!/^[1-9]\d*$/.test(value)) {
                      return Promise.reject(
                        new Error("Hours Required must be greater than 0")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                maxLength={4}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  form.setFieldsValue({ hours_required: value });
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* BUTTON */}
        <Form.Item className="submit-btn">
          {/* STAFF HOUSE */}
          <Form.Item name="is_staffhouse" valuePropName="checked">
            <Checkbox
              onChange={(e) => {
                const checked = e.target.checked;
                setIsStaffHouse(checked);
                form.setFieldsValue({ is_staffhouse: checked });

                if (!checked) {
                  form.setFieldsValue({
                    move_in_date: null,
                    move_out_date: null,
                  });
                  setFileList([]);
                  setPreviewUrl("");
                }
              }}
            >
              Staff House
            </Checkbox>
          </Form.Item>

          {isStaffHouse && (
            <>
              <Row gutter={12}>
                <Col xs={24} md={12}>
                  <Form.Item name="move_in_date" label="Move In Date">
                    <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item name="move_out_date" label="Move Out Date">
                    <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                className="move-out-upload"
                name="move_out_form"
                label="Upload Move Out Form"
              >
                <Upload
                  beforeUpload={() => false}
                  maxCount={1}
                  accept=".jpg,.jpeg,.png,.pdf"
                  fileList={fileList}
                  onChange={({ fileList }) => {
                    setFileList(fileList);

                    if (fileList.length > 0) {
                      const file = fileList[0].originFileObj;

                      if (file) {
                        setPreviewUrl(URL.createObjectURL(file));
                      }
                    } else {
                      setPreviewUrl("");
                    }
                  }}
                >
                  <Button icon={<UploadOutlined />}>Choose File</Button>
                </Upload>
                {fileList.length > 0 && (
                  <div className="uploaded-preview">
                    {fileList[0].type?.startsWith("image/") ? (
                      <img
                        src={previewUrl}
                        alt="Preview"
                        className="preview-image"
                        style={{ cursor: "pointer" }}
                        onClick={() => setPreviewVisible(true)}
                      />
                    ) : (
                      <Button
                        type="default"
                        onClick={() => setPreviewVisible(true)}
                        style={{ marginTop: 10 }}
                      >
                        Preview PDF
                      </Button>
                    )}

                    <Modal
                      open={previewVisible}
                      footer={null}
                      onCancel={() => setPreviewVisible(false)}
                      width={900}
                    >
                      {fileList[0].type?.startsWith("image/") ? (
                        <img
                          src={previewUrl}
                          alt="Preview"
                          style={{
                            width: "100%",
                            borderRadius: 8,
                          }}
                        />
                      ) : (
                        <iframe
                          src={previewUrl}
                          title="PDF Preview"
                          width="100%"
                          height="700"
                          style={{ border: "none" }}
                        />
                      )}
                    </Modal>
                  </div>
                )}
              </Form.Item>
            </>
          )}
          <Button type="primary" htmlType="submit" loading={loading} block>
            Add Intern
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateInterns;
